import beauthBrowser from '@/lib/beauth/beauth.browser';
import notify from '@/lib/notify/notify';
import securityEventKicks, { type TypeSecurityEvent } from '@/function/auth/security.event.kicks';
import tokenSidOf from '@/function/auth/token.sid.of';
import { dashboardApi } from '@/store/api/base/api.base';
import { sessionClosed } from '@/store/auth/auth.slice';
import type { TypeAppDispatch } from '@/store/store';

export default function securityEventHandle(dispatch: TypeAppDispatch, event: TypeSecurityEvent | null | undefined): void {
    if (securityEventKicks(event, tokenSidOf(beauthBrowser.token()))) {
        void beauthBrowser.signOut().catch(() => undefined).finally(() => {
            dispatch(sessionClosed());
            dispatch(dashboardApi.util.resetApiState());
            notify.notice('warning', 'Sessione terminata', 'Questa sessione è stata chiusa: accedi di nuovo.');
        });
        return;
    }
    dispatch(dashboardApi.util.invalidateTags(['Account', 'Session', 'Passkey', 'Connection', 'Access']));
}
